import http from './http-common';
class LanguagesService {
    getSupportedLanguages() {
        return http.get('/supported-languages');
    }
}

export default new LanguagesService();
